(() => {
  if (window.StriveProductCardsReady) return;
  window.StriveProductCardsReady = true;

  const applyVariant = (control, card) => {
    const variantData = control.dataset;
    if (!card) return;

    card.querySelectorAll('[data-strive-card-link]').forEach((link) => {
      link.href = variantData.variantUrl;
    });

    card.querySelectorAll('.strive-product-card__image, .strive-quick-sheet__image').forEach((image) => {
      if (!variantData.variantImage) return;
      image.src = variantData.variantImage;
      image.srcset = variantData.variantImage;
      image.alt = variantData.variantImageAlt || image.alt;
    });

    const available = variantData.variantAvailable === 'true';
    card.querySelectorAll('.product-variant-id').forEach((variantInput) => {
      variantInput.value = variantData.variantId;
      variantInput.disabled = !available;
    });
    card.querySelectorAll('.strive-product-card__add').forEach((addButton) => {
      addButton.disabled = !available;
      const label = addButton.querySelector('[data-strive-add-label]');
      if (label) label.textContent = available ? 'Agregar al carrito' : 'Agotado';
    });

    card.querySelectorAll('[data-strive-card-price], [data-strive-sheet-price]').forEach((price) => {
      const compare = variantData.variantCompare;
      price.innerHTML = `${compare ? `<s>${compare}</s>` : ''}<span class="${compare ? 'is-sale' : ''}">${variantData.variantPrice}</span>`;
    });

    const badges = card.querySelector('.strive-card-badges');
    const offerBadge = badges?.querySelector('[data-strive-offer-badge]');
    if (offerBadge) {
      const compare = Boolean(variantData.variantCompare);
      const discount = Number.parseInt(variantData.variantDiscount, 10) || 0;
      offerBadge.hidden = !compare;
      offerBadge.textContent = compare && discount
        ? `${offerBadge.dataset.offerLabel} -${discount}%`
        : offerBadge.dataset.offerLabel;
      badges.classList.toggle('has-offer', compare);
    }

    card.querySelectorAll('[data-strive-variant-select]').forEach((select) => {
      if (select !== control) select.value = variantData.variantId;
    });
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-strive-variant-select]');
    if (!select) return;

    const selectedOption = select.selectedOptions[0];
    const card = select.closest('[data-strive-product-card]');
    if (!selectedOption || !card) return;

    applyVariant(selectedOption, card);
  });

  const closeSheet = (sheet) => {
    if (!sheet?.open) return;
    sheet.close();
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-strive-sheet-open]');
    if (openButton) {
      const card = openButton.closest('[data-strive-product-card]');
      const sheet = card?.querySelector('[data-strive-quick-sheet]');
      if (!sheet) return;

      const select = sheet.querySelector('[data-strive-variant-select]');
      const input = sheet.querySelector('.product-variant-id');
      const addButton = sheet.querySelector('.strive-quick-sheet__add');
      if (select) select.selectedIndex = 0;
      if (input) {
        input.value = '';
        input.disabled = true;
      }
      if (addButton) {
        addButton.disabled = true;
        const label = addButton.querySelector('[data-strive-add-label]');
        if (label) label.textContent = 'Agregar al carrito';
      }

      sheet.showModal();
      document.body.classList.add('strive-quick-sheet-open');
      window.requestAnimationFrame(() => select?.focus({ preventScroll: true }));
      return;
    }

    const closeButton = event.target.closest('[data-strive-sheet-close]');
    if (closeButton) closeSheet(closeButton.closest('[data-strive-quick-sheet]'));
  });

  document.addEventListener('click', (event) => {
    const sheet = event.target.closest('[data-strive-quick-sheet]');
    if (!sheet || event.target !== sheet) return;
    const bounds = sheet.getBoundingClientRect();
    const inside = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    if (!inside) closeSheet(sheet);
  });

  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('[data-strive-quick-sheet]')) return;
    document.body.classList.remove('strive-quick-sheet-open');
  }, true);

  const closeOpenSheetAfterAdd = () => {
    const sheet = document.querySelector('[data-strive-quick-sheet][open]');
    closeSheet(sheet);
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, closeOpenSheetAfterAdd);
  }
})();
